/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class ProposalStatusEnum.
* @enum {}
* @readonly
*/
export default class ProposalStatusEnum {
    
        /**
         * value: "提案済み"
         * @const
         */
        "提案済み" = "提案済み";

    
        /**
         * value: "取り消し済み"
         * @const
         */
        "取り消し済み" = "取り消し済み";

    
        /**
         * value: "マッチ"
         * @const
         */
        "マッチ" = "マッチ";

    
        /**
         * value: "成約済み"
         * @const
         */
        "成約済み" = "成約済み";

    
        /**
         * value: "予約中"
         * @const
         */
        "予約中" = "予約中";

    
        /**
         * value: "送信失敗"
         * @const
         */
        "送信失敗" = "送信失敗";

    
        /**
         * value: "予約取消"
         * @const
         */
        "予約取消" = "予約取消";

    

    /**
    * Returns a <code>ProposalStatusEnum</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/ProposalStatusEnum} The enum <code>ProposalStatusEnum</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

